module.exports = __webpack_public_path__ + "img/CH01-028-029.9e4d4413.jpg";